/* src/app/modules/consultant/consultant.component.css */
/*# sourceMappingURL=consultant.component.css.map */
